import { AxiosAdapter } from "../commons/adapters";
import { QueryPagination } from "../commons/interfaces";
import { buildQuery } from "../commons/utils/helpers";
import { IServicesIaRequestDto } from "../pages/manager/servicios-ia/configuraion/servicios/interfaces/IServicesIaBackend";

const http = new AxiosAdapter();
const BASE_URL = '/v1/services-ia-configuracion';

export const getAllServicesIaService = async (query?: QueryPagination) => {
    try {
        return await http.get<any>(`${BASE_URL}?${buildQuery(query)}`);
    } catch (error: any) {
        if (error && !error.ok) return error;
        console.error('getAllServicesIaService error', error);
    }
}

export const getServicesIaByIdService = async (id: string) => {
    try {
        return await http.get<any>(`${BASE_URL}/${id}`);
    } catch (error: any) {
        if (error && !error.ok) return error;
        console.error('getServicesIaByIdService error', error);
    }
}

export const createServicesIaService = async (data: IServicesIaRequestDto) => {
    try {
        return await http.post<any>(BASE_URL, data, null);
    } catch (error: any) {
        if (error && !error.ok) return error;
        console.error('createServicesIaService error', error);
    }
}

export const updateServicesIaService = async (id: string, data: IServicesIaRequestDto) => {
    try {
        return await http.put<any>(`${BASE_URL}/${id}`, data);
    } catch (error: any) {
        if (error && !error.ok) return error;
        console.error('updateServicesIaService error', error);
    }
}

export const deleteServicesIaService = async (id: string, query?: QueryPagination) => {
    try {
        return await http.deleteTable<any>(`${BASE_URL}/${id}?${buildQuery(query)}`);
    } catch (error: any) {
        if (error && !error.ok) return error;
        console.error('deleteServicesIaService error', error);
    }
}

export const restoreServicesIaService = async (id: string, query?: QueryPagination) => {
    try {
        return await http.patchTable<any>(`${BASE_URL}/${id}/restore?${buildQuery(query)}`);
    } catch (error: any) {
        if (error && !error.ok) return error;
        console.error('restoreServicesIaService error', error);
    }
}
